import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import CryptoJS from "crypto-js";
import { decryptAndRetrieveData, encryptAndStoreData } from "../components/login/encript-decript";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;
const FEEDBACK_URL = process.env.REACT_APP_FEEDBACK_URL


const user = decryptAndRetrieveData("isAuth", '123456789')

const initialState = {
    todos: [],
    isLoading: false,
    showModel: false,
    isSuccess: false,
    companiesopen: false,
    isAuth: user === "true",
    step: 0,
    cordinate: {},
    accessToken: localStorage.getItem("accessToken") || null,
    route:[],
    titlename:'',
    companydata:[],
};

export const register = createAsyncThunk('register', async (param, thunkAPI) => {
    localStorage.setItem('USERNAME_TO_CONFIRM', param.email)
    localStorage.setItem('PASSWORD_TO_CONFIRM', param.password)
    param.password = CryptoJS.SHA256(param.password).toString();

    try {
        const res = await axios.post(API_URL + "/signup", param);
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const login = createAsyncThunk('login', async (payload, thunkAPI) => {
    payload.password = CryptoJS.SHA256(payload.password).toString();

    try {
        const res = await axios.post(API_URL + "/signin", payload);
        if (res.data) {
            encryptAndStoreData("isAuth", "true", '123456789')
            // localStorage.setItem("isAuth", "true");
            localStorage.setItem("accessToken", res?.data?.access_token);
        }
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const forgotPassword = createAsyncThunk('forgotpassword', async (email, thunkAPI) => {
    try {
        const res = await axios.post(API_URL + "/reset-password", { email });
        return res.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }

});

export const resetPassword = createAsyncThunk('resetPassword', async (values, thunkAPI) => {
    values.password = CryptoJS.SHA256(values.password).toString();

    try {
        const res = await axios.post(API_URL + "/reset-password/verify-code", values);
        return res.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }

});

export const verifyemail = createAsyncThunk('verifyemail', async (paylod, thunkAPI) => {
    try {
        const res = await axios.post(API_URL + "/signup/verify-code", paylod);
        return res.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const reSendVerificationCode = createAsyncThunk('resendverificationcode', async (email, thunkAPI) => {
    try {
        const res = await axios.post(API_URL + "/resend-verification-code", { email });
        return res.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const dropDowns = createAsyncThunk('dropDowns', async (_, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.get(API_URL + "/dropdowns", {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const AddCompanyData = createAsyncThunk('AddCompanyData', async (payload, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/add", payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const UpdateCompanyData = createAsyncThunk('UpdateCompanyData', async (payload, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/update", payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const companies = createAsyncThunk('companies', async (page, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/get", page, {
            // headers: {
            //     Authorization: `Bearer ${accessToken}`,
            // },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});
export const companies_non_mask = createAsyncThunk('companies_non_mask', async (page, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/get-unmasked", page, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const mycompanies = createAsyncThunk('mycompanies', async (page, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");
    try {
        const res = await axios.post(API_URL + "/user/company", page, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        thunkAPI.dispatch(logout());
        toast.error("Your session has expired. Please log in again.");  
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const companiesMap = createAsyncThunk('companiesMap', async (payload, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/coords", payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const deletemycompany = createAsyncThunk('deletemycompany', async (payload, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/delete", payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});
export const companyapproval = createAsyncThunk('companyapproval', async (payload, thunkAPI) => {
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(API_URL + "/company/verify", payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});

export const contactus = createAsyncThunk('contactus', async (payload, thunkAPI) => {
    // const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await axios.post(FEEDBACK_URL + "/feedback", payload);
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
});




const handleAsyncActions = (builder, asyncThunk, stateKey) => {
    builder
        .addCase(asyncThunk.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(asyncThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state[stateKey] = action.payload;
        })
        .addCase(asyncThunk.rejected, (state) => {
            state.isLoading = false;
            state[stateKey] = [];
            
            // localStorage.setItem("isAuth", "false");
        });
};

const counterSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        logout: (state) => {
            state.isAuth = false;
            localStorage.removeItem("isAuth");
            localStorage.removeItem("accessToken");
        },
        showSuccessModel: (state) => {
            state.isSuccess = true;
        },
        signinmodal: (state) => {
            state.showModel = true;
        },
        signinmodalclose: (state) => {
            state.showModel = false;
        },
        closeSuccessModel: (state) => {
            state.isSuccess = false;
        },
        showcompanies: (state) => {
            state.companiesopen = true
        },
        nextstep: (state) => {
            state.step = state.step + 1
        },
        previousstep: (state) => {
            state.step = state.step - 1
        },
        initialstep: (state) => {
            state.step = 0
        },
        setsteps: (state, action) => {
            state.step = action.payload;
        },
        setloader: (state) => {
            if (state.isLoading === false) {
                state.isLoading = true
            } else {
                state.isLoading = false
            }
        },
        setcordinate: (state, data) => {
            state.cordinate = data?.payload
        },
        setroute:(state,data)=>{
            state.route = data
        },
        settitlename:(state,data)=>{
            state.titlename = data
        },
        setcompanydata:(state,data)=>{
            state.companydata=data
        }

    },
    extraReducers: (builder) => {
        handleAsyncActions(builder, register, 'register');
        handleAsyncActions(builder, login, 'login');
        handleAsyncActions(builder, forgotPassword, 'forgotpassword');
        handleAsyncActions(builder, resetPassword, 'resetPassword');
        handleAsyncActions(builder, verifyemail, 'verifyemail');
        handleAsyncActions(builder, reSendVerificationCode, 'resendverificationcode');
        handleAsyncActions(builder, dropDowns, 'dropDowns');
        handleAsyncActions(builder, AddCompanyData, 'AddCompanyData');
        handleAsyncActions(builder, UpdateCompanyData, 'UpdateCompanyData');
        handleAsyncActions(builder, companies, 'companies');
        handleAsyncActions(builder, mycompanies, 'mycompanies');
        handleAsyncActions(builder, deletemycompany, 'deletemycompany');
        handleAsyncActions(builder, contactus, 'contactus');
        handleAsyncActions(builder, companies_non_mask, 'companies_non_mask');
        handleAsyncActions(builder, companyapproval, 'companyapproval');
        // handleAsyncActions(builder, companiesMap, 'companiesMap');
        

        builder.addCase(companiesMap.fulfilled, (state, action) => {
            state.isLoading = false;
            state.companiesMap = action.payload;
            state.cordinate = action.payload;
        });
    },
});

export const { logout, showSuccessModel, closeSuccessModel, showcompanies, nextstep, previousstep, initialstep, setloader, setcordinate, setsteps ,setroute,settitlename,setcompanydata,signinmodal,signinmodalclose} = counterSlice.actions


export default counterSlice.reducer;
